import { render, staticRenderFns } from "./changepwd.vue?vue&type=template&id=347993c2&scoped=true"
import script from "./changepwd.vue?vue&type=script&lang=js"
export * from "./changepwd.vue?vue&type=script&lang=js"
import style0 from "./changepwd.vue?vue&type=style&index=0&id=347993c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347993c2",
  null
  
)

export default component.exports